module.exports = __webpack_public_path__ + "img/EYE.146ba94f.svg";